const PetitionError = require('../../petitionError');
const { del } = require('../../httpRequester');

class RemoveThirdPartyTokenException extends PetitionError {
  static maxTokens = 'Max_tokens';

  constructor(code) {
    super('Remove Token', code);
  }
}

async function removeThirdPartyToken(tokenName, token) {
  const response = await del('users/third_party_token', { tokenName }, token);

  if (response.result !== RemoveThirdPartyTokenException.success) {
    throw new RemoveThirdPartyTokenException(response.result);
  } else {
    return response.user; // TODO transform
  }
}

module.exports = { removeThirdPartyToken, RemoveThirdPartyTokenException };
